// magical touchAction value
export const TOUCH_ACTION_COMPUTE = 'compute';
export const TOUCH_ACTION_AUTO = 'auto';
export const TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
export const TOUCH_ACTION_NONE = 'none';
export const TOUCH_ACTION_PAN_X = 'pan-x';
export const TOUCH_ACTION_PAN_Y = 'pan-y';
